module.exports = __webpack_public_path__ + "img/brand-8.0f499b96.png";